const storeCommon = {};
const storeCoupon = {
    storeDailyDeals: {},
    storeOptionalWelfare: {},
};
const storeRedBag = {};

const store = { storeCommon, storeCoupon, storeRedBag };

/** 基础结构
const poiListInfo = {
    recallBizId: '',
    poiList: [], //商家列表
    pageNo: 1,
    bottomTipID: '', //底部提示模块的ID，用于滚动加载
    poiContainerID: '', //商家列表容器ID，用于滚动加载
};
const couponListInfo = {
    recallBizId: '', //也有可能是个数组
    couponList: [],
    gift_value: 0,
};
*/

// 公共信息
export function initCommon() {
    storeCommon.phone = '';
    storeCommon.deviceId = '';
    storeCommon.structInfo = {};
    storeCommon.loginSuccessCb = null;
    storeCommon.isLoading = false;
    storeCommon.isShowRedBag = false;
    storeCommon.isShowCoupon = false;
}

// 每日优惠
export function initDailyDeals() {
    const { storeDailyDeals } = storeCoupon;
    storeDailyDeals.recallBizId = '';
    storeDailyDeals.tabsContainerID = '';
    storeDailyDeals.tabsInfo = [];
    storeDailyDeals.poiData = {}; // 商家信息缓存
    storeDailyDeals.effectData = {
        // 优惠券信息缓存
        gift_value: '',
    };
}

// 福利自选
export function initWelfare() {
    const { storeOptionalWelfare } = storeCoupon;
    storeOptionalWelfare.tabsContainerID = '';
    storeOptionalWelfare.poiData = {}; // 商家信息缓存
    storeOptionalWelfare.recallBizId = '';
    storeOptionalWelfare.tabsInfo = [];
    storeOptionalWelfare.isShowWelfare = false;
    storeOptionalWelfare.effectData = {
        leftRecvNum: 0,
    };
    storeOptionalWelfare.isWelfare = (recallBizId) => {
        const res = storeOptionalWelfare.tabsInfo.some((item) => item.recallBizId === recallBizId);
        return res;
    };
}

// 红包专区
export function initRedBag() {
    storeRedBag.recallBizId = '';
    storeRedBag.poiData = {}; // 商家信息缓存
    storeRedBag.tabsContainerID = '';
    storeRedBag.tabsInfo = [];
    storeRedBag.effectData = {}; // giftInfo
}

export function initCoupon() {
    storeCoupon.recallBizId = '';
    storeCoupon.tabsContainerID = '';
}

store.init = () => {
    initCoupon();
    initCommon();
    initDailyDeals();
    initWelfare();
    initRedBag();
};
// TODO
window.store = store;
export default store;
